<template>
  <div class="as-tab-team">
    <div class="as-active">{{ match.home_team.name }}</div>
    <div>{{ match.away_team.name }}</div>
  </div>
  <h2>tỷ lệ ghi/mất bàn thing</h2>
  <div class="as-tab-team">
    <div>30 trận gần nhất</div>
    <div>50 trận gần nhất</div>
  </div>
  <div class="as-fx-comparision as-scoreComp">
    <ul class="as-fx-data-left">
      <li class="as-hScoredLi as-hScoredLi1">
        <span class="as-fx-c-l home-bg" style="width: 16%"></span>
        <span class="as-fx-c2 as-green">16</span>
      </li>
      <li class="as-hScoredLi as-hScoredLi2" style="display: none">
        <span class="as-fx-c-l as-home-bg" style="width: 16%"></span>
        <span class="as-fx-c2 as-green">16</span>
      </li>
    </ul>
    <span class="as-fx-c-3">
      <span>1~15</span>
    </span>
    <ul class="as-fx-data-right">
      <li class="as-gScoredLi as-gScoredLi1">
        <span class="as-fx-c-r as-away-bg" style="width: 15%"></span>
        <span class="as-fx-c2">15</span>
      </li>
      <li class="as-gScoredLi as-gScoredLi2" style="display: none">
        <span class="as-fx-c-r as-away-bg" style="width: 15%"></span>
        <span class="as-fx-c2">15</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { IMatch, IAnalysis } from "~src/interfaces";

interface IProps {
  match: IMatch;
  data: IAnalysis;
}

const props = withDefaults(defineProps<IProps>(), {});
</script>

<script lang="ts">
export default {};
</script>
